module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/html-09ce7b6e207fb4a6d7d30743475368bd.svg";